function toolGallery() {
    document.querySelectorAll('[data-tool-gallery]').forEach((gallery) => {
        const track = gallery.querySelector('[data-tool-gallery-track]');
        const slides = Array.from(gallery.querySelectorAll('[data-tool-gallery-slide]'));
        const previousButton = gallery.querySelector('[data-tool-gallery-previous]');
        const nextButton = gallery.querySelector('[data-tool-gallery-next]');
        const status = gallery.querySelector('[data-tool-gallery-status]');

        if (!track || slides.length < 2 || !previousButton || !nextButton) return;

        let activeIndex = 0;
        let scrollFrame = null;

        const render = () => {
            previousButton.disabled = activeIndex === 0;
            nextButton.disabled = activeIndex === slides.length - 1;
            if (status) status.textContent = `${activeIndex + 1} / ${slides.length}`;
        };

        const moveTo = (index) => {
            activeIndex = Math.max(0, Math.min(index, slides.length - 1));
            track.scrollTo({left: slides[activeIndex].offsetLeft, behavior: 'smooth'});
            render();
        };

        previousButton.addEventListener('click', () => moveTo(activeIndex - 1));
        nextButton.addEventListener('click', () => moveTo(activeIndex + 1));
        track.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') {
                event.preventDefault();
                moveTo(activeIndex - 1);
            }
            if (event.key === 'ArrowRight') {
                event.preventDefault();
                moveTo(activeIndex + 1);
            }
        });
        track.addEventListener('scroll', () => {
            if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
            scrollFrame = window.requestAnimationFrame(() => {
                const slideWidth = track.clientWidth || 1;
                activeIndex = Math.max(0, Math.min(Math.round(track.scrollLeft / slideWidth), slides.length - 1));
                render();
            });
        }, {passive: true});

        render();
    });
}

export {toolGallery};
